module.exports = __webpack_public_path__ + "static/media/ball-pile.54d454a4.svg";